import React, { useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import EventCard from "../components/EventCard";
import Loading from "../components/Loading";
import { useAuth } from "../context/AuthContext";
import AdminContentForm, { AdminNewButton, AdminItemWrap, useAdminSection } from "../components/AdminContentForm";

export default function EventsPage() {
  const { user } = useAuth();
  const isAdmin = !!user?.is_admin;
  const [tab, setTab] = useState("previous");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    const url = tab === "upcoming" ? "/events/upcoming" : "/events/previous";
    api.get(url, { params: { limit: 30 } })
      .then(r => setItems(r.data.results || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [tab]);
  useEffect(() => { load(); }, [load]);

  const admin = useAdminSection("event", load);

  return (
    <div data-testid="page-events">
      <div className="mb-6 border-b border-[color:var(--sat-border)] pb-4 flex items-end justify-between flex-wrap gap-4">
        <div>
          <div className="sat-label sat-cyan">CHANNEL // 003</div>
          <h1 className="font-display font-bold text-3xl md:text-4xl mt-1">CHRONOLOGY</h1>
          <p className="text-sm text-[color:var(--sat-text-dim)] mt-2">Milestones from the historical record and forthcoming ceremonies.</p>
        </div>
        <div className="flex gap-2 items-center">
          <button data-testid="events-tab-historic" onClick={() => setTab("previous")}
            className={`sat-btn ${tab === "previous" ? "sat-btn-solid" : ""}`}>◀ HISTORIC</button>
          <button data-testid="events-tab-upcoming" onClick={() => setTab("upcoming")}
            className={`sat-btn ${tab === "upcoming" ? "sat-btn-solid" : ""}`}>▶ UPCOMING</button>
          {isAdmin && <AdminNewButton section="event" label="Event" onClick={admin.openNew} />}
        </div>
      </div>

      {loading ? <Loading message="ACCESSING ARCHIVES" /> : (
        <div className="relative pl-4 md:pl-8 border-l border-[color:var(--sat-border-bright)]">
          <div className="flex flex-col gap-4">
            {items.map(e => (
              <div key={e.id} className="relative">
                <div className="absolute -left-[22px] md:-left-[38px] top-6 w-3 h-3 bg-[color:var(--sat-cyan)] sat-glow" />
                <AdminItemWrap item={e} isAdmin={isAdmin} onEdit={admin.openEdit} onDelete={admin.onDelete}>
                  <EventCard event={e} />
                </AdminItemWrap>
              </div>
            ))}
          </div>
          {items.length === 0 && <div className="text-center py-16 sat-label">NO EVENTS ON RECORD</div>}
        </div>
      )}

      {admin.formOpen && (
        <AdminContentForm
          section="event"
          initial={admin.editing}
          initialId={admin.editing?.admin_id}
          onClose={admin.closeForm}
          onSaved={admin.onSaved}
        />
      )}
    </div>
  );
}
